module.exports = __webpack_public_path__ + "static/img/anxunu10.94385170.png";